/**
 * Filtre les colonnes exportables
 * Par défaut : toutes les colonnes avec Header + accessor, sauf disableExport
 */
export const getExportableColumns = (columns = []) =>
  columns.filter(col => !col.disableExport && col.Header && col.accessor);

/**
 * Extrait la valeur d'une colonne pour l'export
 * - utilise exportValue si défini
 * - sinon utilise accessor (fonction ou string)
 * - sinon renvoie "-"
 */
export const extractValueFromColumn = (column, row) => {
  if (column.disableExport) return undefined;

  let rawValue;

  // accessor fonction
  if (typeof column.accessor === "function") {
    rawValue = column.accessor(row);
  } 
  // accessor string
  else if (typeof column.accessor === "string") {
    rawValue = row[column.accessor];
  } 
  // fallback
  else {
    rawValue = undefined;
  }

  // transformation custom
  if (column.exportValue) {
    return column.exportValue(rawValue, row);
  }

  // valeur brute ou "-"
  return rawValue ?? "-";
};
